import { render, staticRenderFns } from "./BatchProductUpgrade.vue?vue&type=template&id=00adcacd"
import script from "./BatchProductUpgrade.vue?vue&type=script&lang=js"
export * from "./BatchProductUpgrade.vue?vue&type=script&lang=js"
import style0 from "./BatchProductUpgrade.vue?vue&type=style&index=0&id=00adcacd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports